import { RenderInfo } from '../../RenderInfo/RenderInfo';
import type { VirtualCardConfig, VirtualCardData } from '../types';

type CardDetailsProps = {
  data: VirtualCardData;
  config: VirtualCardConfig;
};

export const CardDetails = ({ data, config }: CardDetailsProps) => {
  const shouldShowToCharge = data.issuingBalance > 0;
  const shouldShowToRefund = data.issuingBalance < 0;

  return (
    <div className="card-detail">
      <RenderInfo
        title="To charge"
        content={config.currencyFormatter(
          shouldShowToCharge ? data.issuingBalance : 0
        )}
        isTextGrey={!shouldShowToCharge}
      />
      <RenderInfo
        title="To refund"
        content={config.currencyFormatter(
          shouldShowToRefund ? -data.issuingBalance : 0
        )}
        isTextGrey={!shouldShowToRefund}
      />
      {!config.cardIsBlur && <RenderInfo title="PIN" id="card-pin" />}
    </div>
  );
};
